(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.addEventListener('load', function () {
  var programFamilyForm = '#BrochureStep1SfType_programFamily';
  var programForm = '#BrochureStep1SfType_program';
  var campusForm = '#BrochureStep1SfType_campus';
  var btnBackFirstStep = document.getElementById('brochures_return-first');
  var btnBackSecondStep = document.getElementById('brochures_return-second');
  var heightHeader = document.querySelector('.all-top-infos').clientHeight;
  var messageError = document.querySelector('.error');
  var buttonSubmit = document.querySelector('.brochures_bottom button');
  var buttonParent = document.querySelector('.brochures_bottom');
  var programFamilyChoices = Array.from(document.querySelectorAll(programFamilyForm + ' input[type="radio"]'));
  var programChoices = Array.from(document.querySelectorAll(programForm + ' input[type="radio"]'));
  var campusChoices = Array.from(document.querySelectorAll(campusForm + ' input[type="radio"]'));

  var changeCampus = function changeCampus(programValue) {
    // Hide campuses which are not children of the program
    var visibleCampusChoices = campusChoices.filter(function (campusChoice) {
      var datasetArray = JSON.parse(campusChoice.dataset.parentPrograms);

      if (datasetArray.includes(programValue)) {
        campusChoice.parentNode.classList.remove('hide');
        return true;
      } else {
        campusChoice.parentNode.classList.add('hide');
        return false;
      }
    }); // Retrieve the visible choices in the program formgroup

    if (visibleCampusChoices.length > 0) {
      visibleCampusChoices[0].checked = true;
      var campusChangeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      visibleCampusChoices[0].dispatchEvent(campusChangeEvent);
    } else {
      // If there is no choice available, then uncheck the selected choice to avoid form validation with invalid values
      document.querySelector(campusForm + ' input:checked').checked = false;
    }
  };

  if (window.isLowerThan('tablet')) {
    buttonSubmit.classList.add('disabled');
    buttonSubmit.setAttribute('disabled', 'disabled');
    buttonParent.addEventListener('click', function (evt) {
      if (evt.target.parentNode.classList.contains('disabled')) {
        evt.preventDefault();
        messageError.classList.remove('hide');
      }
    });
  } // Program family inputs event listener


  programFamilyChoices.forEach(function (elm) {
    elm.addEventListener('change', function (evt) {
      var choosenProgramFamilyId = evt.target.value; // Hide programs which are not children of the program family

      var visibleProgramChoices = programChoices.filter(function (programChoice) {
        if (programChoice.dataset.parentFamily === choosenProgramFamilyId) {
          programChoice.parentNode.classList.remove('hide');
          return true;
        } else {
          programChoice.parentNode.classList.add('hide');
          return false;
        }
      }); // Retrieve the visible choices in the program formgroup

      if (visibleProgramChoices.length > 0) {
        visibleProgramChoices[0].checked = true;
        var programChangeEvent = new Event('change', {
          bubbles: true,
          cancelable: true
        });
        visibleProgramChoices[0].dispatchEvent(programChangeEvent);
      } else {
        // If there is no choice available, then uncheck the selected choice to avoid form validation with invalid values
        document.querySelector(programForm + ' input:checked').checked = false; // Rare but possible case : the program family have programs without campus
        // Clean the campus column in this case

        document.querySelector(campusForm + ' input:checked').checked = false;
        document.querySelectorAll(campusForm + ' input').forEach(function (elm) {
          elm.parentNode.classList.add('hide');
        });
      }
    });

    if (window.isLowerThan('tablet')) {
      elm.addEventListener('click', function (evt) {
        if (messageError != null) {
          messageError.classList.add('hide');
        }

        var currentFamilyGroup = evt.target.closest('fieldset');
        currentFamilyGroup.classList.remove('current');
        currentFamilyGroup.nextElementSibling.classList.add('current');
        window.scrollTo({
          top: heightHeader,
          behavior: 'smooth'
        });
      });
    }
  });
  var programParents = [];
  var programs = []; // Program inputs event listener

  programChoices.forEach(function (elm, key) {
    // If program is a parent, don't bind this event below
    if (!elm.hasAttribute('data-child-programs')) {
      // If program is a parent, don't bind this event below
      if (!elm.hasAttribute('data-child-programs')) {
        elm.addEventListener('change', function (evt) {
          var choosenProgramId = evt.target.value; // Hide campuses which are not children of the program

          changeCampus(choosenProgramId);
        });
      } else {
        programParents.push(elm);
      }

      if (window.isLowerThan('tablet')) {
        elm.addEventListener('click', function (evt) {
          var currentProgramGroup = evt.target.closest('fieldset');
          currentProgramGroup.classList.remove('current');
          currentProgramGroup.nextElementSibling.classList.add('current');
          buttonSubmit.classList.remove('disabled');
          buttonSubmit.removeAttribute('disabled');

          if (messageError != null) {
            messageError.classList.add('hide');
          }

          window.scrollTo({
            top: heightHeader,
            behavior: 'smooth'
          });
        });
        btnBackFirstStep.addEventListener('click', function (evt) {
          var currentFamilyGroup = evt.target.closest('fieldset');
          currentFamilyGroup.classList.remove('current');
          currentFamilyGroup.previousElementSibling.classList.add('current');
          buttonSubmit.classList.add('disabled');
          buttonSubmit.setAttribute('disabled', 'disabled');
        });
      }

      programs.push(elm);
    } else {
      programParents.push(elm);
    }
  });

  if (programParents.length > 0) {
    programParents.forEach(function (elm) {
      var childPrograms = JSON.parse(elm.dataset.childPrograms);

      if (childPrograms.length > 0) {
        // Prevent accordion to trigger in front office and remove parent program from submit
        elm.removeAttribute('name');
        elm.setAttribute('name', 'parent');
        elm.removeAttribute('required');
        var childElement = document.createElement('ul');
        childElement.classList.add('element-parent');
        childPrograms.forEach(function (child) {
          var programChild = document.querySelector('input[value="' + child + '"]');

          if (programChild) {
            programChild.classList.add('program-child');
            var parentNode = programChild.parentNode;
            childElement.appendChild(parentNode);
          }
        });

        if (childElement.hasChildNodes()) {
          var parentElementNode = elm.parentNode;
          parentElementNode.appendChild(childElement);
          parentElementNode.classList.add('with-childs');
        }
      } // Manage accordion to close if parent is selected and if we have a single parent


      elm.addEventListener('change', function () {
        if (elm.checked) {
          var elementParent = elm.parentNode;
          var elements = elementParent.querySelector('.element-parent');

          if (elements && elements.hasChildNodes()) {
            var firstInput = elements.querySelector('.program-child:first-child');

            if (firstInput) {
              firstInput.checked = true;
              var choosenProgramId = firstInput.value; // Hide campuses which are not children of the program

              changeCampus(choosenProgramId);
            }
          }
        }

        elm.addEventListener('click', function () {
          if (elm.classList.contains('open')) {
            elm.checked = false;
            elm.classList.remove('open');
          }
        });

        if (!elm.classList.contains('open')) {
          elm.classList.add('open');
        }
      });
    }); // Close parent accordion if another program is selected

    programs.forEach(function (elm) {
      if (!elm.classList.contains('program-child')) {
        elm.addEventListener('change', function () {
          var parentEltChecked = document.querySelector('input[name="parent"]:checked');

          if (parentEltChecked) {
            parentEltChecked.checked = false;
            parentEltChecked.classList.remove('open');
          }
        });
      }
    });
  } // Campus inputs event listener


  campusChoices.forEach(function (elm) {
    elm.addEventListener('change', function (evt) {
      if (window.isLowerThan('tablet')) {
        btnBackSecondStep.addEventListener('click', function (evt) {
          var currentFamilyGroup = evt.target.closest('fieldset');
          currentFamilyGroup.classList.remove('current');
          currentFamilyGroup.previousElementSibling.classList.add('current');
        });
      } // Eventually, we can here interract with the submission button
      // eg. enable it

    });
  }); // After event listeners were created...
  // Choose the first program family at the page load
  // The "check" event will be propagated to program and campus selections

  if (programFamilyChoices.length > 0) {
    var initProgramFamilyChoice = new Event('change', {
      bubbles: true,
      cancelable: true
    });
    programFamilyChoices[0].checked = true;
    programFamilyChoices[0].dispatchEvent(initProgramFamilyChoice);
  }
});

},{}]},{},[1]);
